/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Step_Send_AppInputs */

const en_dashboard_step_send_app = /** @type {(inputs: Dashboard_Step_Send_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send application`)
};

const de_dashboard_step_send_app = /** @type {(inputs: Dashboard_Step_Send_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbung senden`)
};

const fr_dashboard_step_send_app = /** @type {(inputs: Dashboard_Step_Send_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer une candidature`)
};

const es_dashboard_step_send_app = /** @type {(inputs: Dashboard_Step_Send_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar solicitud`)
};

const it_dashboard_step_send_app = /** @type {(inputs: Dashboard_Step_Send_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia candidatura`)
};

const nl_dashboard_step_send_app = /** @type {(inputs: Dashboard_Step_Send_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzend sollicitatie`)
};

const pl_dashboard_step_send_app = /** @type {(inputs: Dashboard_Step_Send_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij aplikację`)
};

const fi_dashboard_step_send_app = /** @type {(inputs: Dashboard_Step_Send_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetä hakemus`)
};

const da_dashboard_step_send_app = /** @type {(inputs: Dashboard_Step_Send_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send ansøgning`)
};

const sv_dashboard_step_send_app = /** @type {(inputs: Dashboard_Step_Send_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skicka ansökan`)
};

/**
* | output |
* | --- |
* | "Send application" |
*
* @param {Dashboard_Step_Send_AppInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_step_send_app = /** @type {((inputs?: Dashboard_Step_Send_AppInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Step_Send_AppInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_step_send_app(inputs)
	if (locale === "fr") return fr_dashboard_step_send_app(inputs)
	if (locale === "es") return es_dashboard_step_send_app(inputs)
	if (locale === "it") return it_dashboard_step_send_app(inputs)
	if (locale === "nl") return nl_dashboard_step_send_app(inputs)
	if (locale === "pl") return pl_dashboard_step_send_app(inputs)
	if (locale === "fi") return fi_dashboard_step_send_app(inputs)
	if (locale === "da") return da_dashboard_step_send_app(inputs)
	if (locale === "sv") return sv_dashboard_step_send_app(inputs)
	return en_dashboard_step_send_app(inputs)
});